import React, { SyntheticEvent, useEffect, useState } from "react";
import numbro from "numbro";

// Material UI
import Slider from "@mui/material/Slider";

// Types
import { NumberRangeFilterWrapperFn } from "@/@types/ui/Table";
import { Row } from "react-table";

export const NumberRangeFilter: NumberRangeFilterWrapperFn =
  (setFilterLocalStorage, fieldItems) =>
  ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    
    const [sliderValue, setSliderValue] = useState<number[]>([-1, -1]);

    const defaultValue = [-1, -1];

    const rowsWithValueCount = preFilteredRows.filter((x: Row) => x.values[id]).length;

    preFilteredRows.forEach((row: Row) => {
      if (row.values[id]) {
        const unformattedValue = row.values[id].props?.unformatedvalue
          ? row.values[id].props.unformatedvalue
          : row.values[id];

        if (defaultValue[0] === -1 && defaultValue[1] === -1) {
          defaultValue[0] = unformattedValue;
          defaultValue[1] = unformattedValue;
        } else {
          defaultValue[0] = Math.min(defaultValue[0], unformattedValue);
          defaultValue[1] = Math.max(defaultValue[1], unformattedValue);
        }
      }
    });

    const minMaxDiff = defaultValue[1] - defaultValue[0];
    const step = minMaxDiff < 10 ? 1 : minMaxDiff < 100 ? 1 : minMaxDiff < 1000 ? 10 : 100;

    // Align the minimum value to the nearest step
    const minAligned = Math.floor(defaultValue[0] / step) * step;
    const maxAligned = Math.ceil(defaultValue[1] / step) * step;

    // Ensure sliderValue updates correctly when filterValue changes
    useEffect(() => {
      if (filterValue) {
        // @ts-ignore filterValue is always number[] as we have no single point slider filters
        setSliderValue([Math.max(minAligned,filterValue[0]), Math.min(maxAligned,filterValue[1])]);
      } else {
        setSliderValue([minAligned, maxAligned]);
      }
    }, [filterValue, preFilteredRows]);

    const handleSliderValue = (_evt: Event, newValue: number | number[]) => {
      setSliderValue(newValue as number[]);
    };

    const handleChange = (_evt: Event | SyntheticEvent<Element, Event>, value: number | number[]) => {
      setFilterLocalStorage(id, value, setFilter);
    };

    return rowsWithValueCount > 0 ? (
      <Slider
        value={sliderValue}
        onChange={handleSliderValue}
        onChangeCommitted={handleChange}
        min={minAligned}
        max={maxAligned}
        valueLabelDisplay="auto"
        color="primary"
        valueLabelFormat={(x) => x}
        step={step}
        disabled={rowsWithValueCount === 0}
      />
    ) : null;
  };
